export default "__VITE_ASSET__DxyghQTQ__"